// extracted by mini-css-extract-plugin
export var brewer_bio = "home-module--brewer_bio--R-NKi";
export var brewer_bio_content = "home-module--brewer_bio_content--UbsjW";
export var brewer_img = "home-module--brewer_img--OagqV";
export var eddie_brewer = "home-module--eddie_brewer--HedQb";
export var header_bg = "home-module--header_bg--V1xGe";
export var home_meet_brewer = "home-module--home_meet_brewer---GkoZ";
export var home_verve_intro = "home-module--home_verve_intro--DUkHA";
export var verve_definition = "home-module--verve_definition--i+paD";
export var verve_noun = "home-module--verve_noun--ltP4R";